var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import * as _ from "lodash";
import { Messages } from 'primereact/messages';
import * as React from "react";
import { connect } from "react-redux";
import * as ProductLineFactory from "../../classes/definitions/brand/productLine";
import ApiRequests from "../../classes/http/ApiRequests";
import HttpRequests from "../../classes/http/HttpRequests";
import ProductLinesList from '../../components/ProductLines/ProductLinesList/ProductLinesList';
import AppRoutes from '../../config/appRoutes';
import ProductLinesReduxProps from "./ProductLinesReduxProps";
var ProductLines = /** @class */ (function (_super) {
    __extends(ProductLines, _super);
    function ProductLines() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.api = new ApiRequests();
        _this.http = new HttpRequests();
        _this.messages = null;
        _this.staticPageId = '';
        _this.brandId = '';
        _this.state = {
            data: []
        };
        _this.isOnlyStaticPage = function () {
            return _this.staticPageId !== "-1" && _this.brandId === "-1";
        };
        _this.getAllStaticProductLines = function () {
            return _this.api.getStaticProductLines(_this.staticPageId);
        };
        _this.getProductLines = function () {
            return _this.api.getProductLines(_this.brandId, _this.staticPageId);
        };
        _this.getAllProductLines = function () {
            var action = _this.isOnlyStaticPage() ? _this.getAllStaticProductLines() : _this.getProductLines();
            action
                .then(function (response) {
                var data = ProductLineFactory.createProductLines(response.data);
                _this.setState({ data: data });
            })
                .catch(function (error) {
                _this.http.handleError(error, _this.messages, 'Не можахме да заредим линията от продукти', _this.props.history);
            });
        };
        _this.toNewProductLine = function () {
            if (_this.isOnlyStaticPage()) {
                _this.props.history.push(AppRoutes.staticPage.path + '/' + _this.staticPageId +
                    AppRoutes.productLine.path);
            }
            else {
                _this.props.history.push(AppRoutes.brand.path + '/' + _this.brandId +
                    AppRoutes.staticPage.path + '/' + _this.staticPageId +
                    AppRoutes.productLine.path);
            }
        };
        // Deleting the item from the state
        _this.deleteItem = function (id) {
            var data = __spreadArrays(_this.state.data);
            var result = data.find(function (item) {
                return item.Id === id;
            });
            var index = data.indexOf(result);
            data.splice(index, 1);
            _this.setState({ data: data });
        };
        _this.toParentProduct = function () {
            if (_this.isOnlyStaticPage()) {
                _this.props.history.push(AppRoutes.staticPage.path + '/' + _this.staticPageId);
            }
            else {
                _this.props.history.push(AppRoutes.brand.path + '/' + _this.brandId +
                    AppRoutes.staticPage.path + '/' + _this.staticPageId);
            }
        };
        return _this;
    }
    ProductLines.prototype.componentDidMount = function () {
        this.staticPageId = _.get(this.props, 'match.params.staticPageId', '-1');
        this.brandId = _.get(this.props, 'match.params.brandId', '-1');
        this.getAllProductLines();
    };
    ProductLines.prototype.render = function () {
        var _this = this;
        var data = this.state.data;
        return (React.createElement("div", { className: "container-fluid" },
            React.createElement("div", { className: "animated fadeIn" },
                React.createElement("h1", { className: "display-3" }, "\u041F\u0440\u043E\u0434\u0443\u043A\u0442\u043E\u0432\u0438 \u043B\u0438\u043D\u0438\u0438"),
                React.createElement("hr", null),
                React.createElement("div", { className: "row" },
                    React.createElement("div", { className: "col-md-12" },
                        React.createElement("div", { className: "list-actions" },
                            React.createElement("button", { className: "btn btn-sm btn-primary", onClick: this.toNewProductLine, type: "button" },
                                React.createElement("i", { className: "fa fa-dot-circle-o" }),
                                " \u041D\u043E\u0432\u0430 \u043F\u0440\u043E\u0434\u0443\u043A\u0442\u043E\u0432\u0430 \u043B\u0438\u043D\u0438\u044F"),
                            React.createElement("a", { onClick: this.toParentProduct },
                                React.createElement("i", { className: "fa fa-backward" }),
                                " \u041D\u0430\u0437\u0430\u0434")),
                        React.createElement(Messages, { ref: function (el) { _this.messages = el; } }),
                        React.createElement(ProductLinesList, { gridData: data, messages: this.messages, deleteItem: this.deleteItem }))))));
    };
    return ProductLines;
}(React.Component));
export default connect(null, ProductLinesReduxProps.mapDispatchToProps)(ProductLines);



//////////////////
// WEBPACK FOOTER
// ./src/views/ProductLines/ProductLines.tsx
// module id = 142
// module chunks = 0